import { useEffect } from 'react';
import { reloadKiosk } from '../helpers/kiosk';

// Detecta la pantalla congelada: si requestAnimationFrame deja de correr pero los timers
// siguen vivos, el compositor de WebKit se colgó (típico con video/decoders en iOS) y la
// única salida es recargar.

const CHECK_MS = 5 * 1000;
const FRAME_TIMEOUT_MS = 15 * 1000;

export const useFreezeWatchdog = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;

    let lastFrame = Date.now();
    let lastCheck = Date.now();

    const tick = () => {
      lastFrame = Date.now();
      rafId = requestAnimationFrame(tick);
    };
    let rafId = requestAnimationFrame(tick);

    // Al volver del segundo plano rAF y los timers estuvieron detenidos: reiniciar contadores.
    const onVisibility = () => {
      lastFrame = Date.now();
      lastCheck = Date.now();
    };
    document.addEventListener('visibilitychange', onVisibility);

    const timer = setInterval(() => {
      const now = Date.now();
      const sinceCheck = now - lastCheck;
      lastCheck = now;

      // Si el propio intervalo se atrasó, iOS estaba frenando los timers: no es un freeze.
      if (sinceCheck > CHECK_MS * 3) {
        lastFrame = now;
        return;
      }

      if (document.visibilityState !== 'visible') {
        lastFrame = now;
        return;
      }

      const sinceFrame = now - lastFrame;
      if (sinceFrame > FRAME_TIMEOUT_MS) {
        reloadKiosk(`pantalla sin frames por ${Math.round(sinceFrame / 1000)} s`);
      }
    }, CHECK_MS);

    return () => {
      cancelAnimationFrame(rafId);
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [enabled]);
};
